import { Typography } from "@mui/material"
import { useIsDesktop } from "common/MediaQueries"
import TowingIcon from "reusable/icons/hamesayat/TowingIcon"
import styled from "styled-components"
import { StyledBody } from "../wrappers/BodyText"
import ModalHeader from "./ModalHeader"

const StyledCaption = styled(Typography).attrs({ variant: "caption" })`
  margin-top: 20px;
  color: ${(p) => p.theme.colors.mazdaRed};
  display: block;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding-bottom: 20px;
  }
`

const TowingModal = () => {
  const isDesktop = useIsDesktop()
  return (
    <>
      <ModalHeader
        icon={<TowingIcon />}
        title="גרירה בתשלום"
        subtitle={
          "גרירה למרכזי השירות המורשים מטעם חברת דלק מוטורס המשתתפים בתוכנית."
        }
      />
      <StyledBody $margin={20}>
        א. אם אין שירותי גרירה בפוליסת הביטוח יינתן שירות גרירה חינם<br></br>
        זאת במידה והרכב אינו במצב נסיעה.
      </StyledBody>
      <StyledBody $margin={isDesktop ? 30 : 1}>
        ב. הגרירה תבוצע לאחד ממרכזי השירות המורשים מטעם דלק מוטורס המשתתפים
        <br></br>בתוכנית, עפ"י בחירת בעל הרכב.
      </StyledBody>
      <StyledBody $margin={isDesktop ? 30 : 1}>
        ג.בעת שמרכז השירות סגור וללא שומר, ייגרר הרכב לחניון לילה של חברת שגריר
        או חברה אחרת ומשם למרכז השירות, עם שובו לפעילות, ללא חיוב הלקוח בעלות
        גרירה נוספת.
      </StyledBody>
      <StyledBody $margin={isDesktop ? 30 : 1}>
        ד.אם קיים שירות גרירה בפוליסת הביטוח, מוקד המסייעת יסייע בהפעלתו
      </StyledBody>
      <StyledCaption>
        *במידה וגרירת הרכב בוצעה שלא באמצעות פוליסת הביטוח של בעל הרכב והרכב לא
        {isDesktop && <br></br>}
        תוקן במרכז השירות של דלק מוטורס, יידרש בעל הרכב לשאת בעלות הגרירה.
      </StyledCaption>
    </>
  )
}

export default TowingModal
